import {QueryClient} from '@tanstack/react-query';
import type {CheckState,FinancialOperatingWorkspace,InterfaceModel} from './model';

export const queryClient=new QueryClient({defaultOptions:{queries:{retry:false,staleTime:15_000,gcTime:300_000}}});
const states=new Set<CheckState>(['ready','attention','blocked','unknown']);

export function workspacePath(model:InterfaceModel,tenantId:string){
  if(!/^ten_[A-Za-z0-9_-]{6,64}$/.test(tenantId))throw new Error('Tenant coordinate refused.');
  return model.workspaceApi.mountPath+model.workspaceApi.pathTemplate.replace('{tenantId}',encodeURIComponent(tenantId));
}

export function financialOperatingWorkspaceQuery(model:InterfaceModel,token:string,tenantId:string){
  return {
    queryKey:['tallyup://projection/interface/financial-operating-workspace/v1',model.workspaceApi.operationIdentity,tenantId],
    queryFn:async():Promise<FinancialOperatingWorkspace>=>{
      const response=await fetch(workspacePath(model,tenantId),{method:'GET',headers:{accept:'application/json',authorization:'Bearer '+token},cache:'no-store'});
      if(!response.ok) throw new Error(`Financial operating workspace read refused (${response.status}).`);
      const workspace=await response.json() as FinancialOperatingWorkspace;
      if(workspace?.schema!=='tallyup.financial-operating-workspace.v1'||workspace.credentialPayloadPresent!==false
        ||workspace.tenantId!==tenantId||!workspace.context||!Array.isArray(workspace.checks)
        ||workspace.checks.length!==model.checks.length) throw new Error('Financial operating workspace response refused.');
      const definitions=new Set(model.checks.map(check=>check.identity));
      if(workspace.checks.some(check=>!definitions.delete(check.definitionIdentity)||!states.has(check.state)
        ||!Number.isInteger(check.evidenceCount)||check.evidenceCount<0||typeof check.observedPosition!=='string'
        ||typeof check.materiality!=='string'||typeof check.nextAction?.enabled!=='boolean'))
        throw new Error('Financial operating workspace does not match the admitted check definitions.');
      return workspace;
    }
  };
}
